// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/item_attributes/salvar
 *
 * Returns the id of the inserted/updated item attribute.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Item_attributes_SalvarResponseDados {
so_item_attribute_id: number
}

export type Item_attributes_SalvarResponse = ApiResponse<Item_attributes_SalvarResponseDados>;

registerResponseContract('Item_attributes_SalvarResponse', {
  so_item_attribute_id: { type: 'number',  required: true },
})
